import { render, staticRenderFns } from "./dropshipping.vue?vue&type=template&id=6338efca&scoped=true"
import script from "./dropshipping.vue?vue&type=script&lang=js"
export * from "./dropshipping.vue?vue&type=script&lang=js"
import style0 from "./dropshipping.vue?vue&type=style&index=0&id=6338efca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6338efca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLink: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/22072026_100728/resources/assets/marketplace/components/BaseLink.vue').default,BaseAlert: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/22072026_100728/resources/assets/marketplace/components/BaseAlert.vue').default})
